import { Alert, Spin } from "@arco-design/web-react";
import { useQuery } from "@tanstack/react-query";

import { fetchCustomizationWorkbench } from "../repo/customizationRepo";
import type { CustomizationDemandVersionOption } from "../types";
import { CustomizationDemandExcelDetailPanel } from "./CustomizationDemandExcelDetailPanel";

type Props = {
  projectId: string;
  demandId: string;
};

/** 微信推送等入口落地的需求版本 Excel 详表只读页。 */
export function CustomizationDemandExcelDetailFeaturePage({ projectId, demandId }: Props) {
  const workbenchQuery = useQuery({
    queryKey: ["customization", "projects", projectId, "workbench", "excel-detail-page"],
    queryFn: () => fetchCustomizationWorkbench(projectId, { view: "preview" }),
  });

  if (workbenchQuery.isLoading || workbenchQuery.isFetching) {
    return <Spin loading style={{ width: "100%", minHeight: 160 }} />;
  }

  if (workbenchQuery.error || !workbenchQuery.data) {
    return <Alert type="error" showIcon content="定制项目加载失败，请稍后重试。" />;
  }

  const workbench = workbenchQuery.data;
  const version =
    workbench.demandVersions.find((item) => item.id === demandId) ??
    fallbackDemandVersion(demandId);

  return (
    <div className="customization-demand-excel-detail-page">
      <CustomizationDemandExcelDetailPanel
        projectId={projectId}
        version={version}
        view="preview"
        projectContext={{
          name: workbench.project.name,
          projectCode: workbench.project.projectCode,
          legacyId: workbench.project.legacyId,
          customerType: workbench.project.customerType,
          tripType: workbench.project.tripType,
          signType: workbench.project.signType,
          dealProgress: workbench.project.dealProgress,
          salesUserName: workbench.project.salesUserName,
          dispatcherUserName: workbench.project.dispatcherUserName,
          operatingCompany: workbench.project.operatingCompany,
          organizationNameSnapshot: workbench.project.primarySchoolNameSnapshot,
          customerName: workbench.project.customerName,
          contactName: workbench.project.contactName,
          projectCreatedAt: version.createdAt,
        }}
      />
    </div>
  );
}

/** 工作台版本列表未命中时，仅保留详表所需的版本身份占位。 */
function fallbackDemandVersion(demandId: string): CustomizationDemandVersionOption {
  return {
    id: demandId,
    versionNumber: "未生成",
    versionSeq: 1,
    createdAt: "",
    isCurrent: false,
  };
}
